





















import { Component, Prop, Vue } from "vue-property-decorator";
import { LoginEnvironment } from "@futuri/cloudsso-client/src/client/types/api";

export type OnLogin = (environment: string) => void;

@Component({
  methods: {
    handleLogin() {
      const view = this as any;
      const select = this.$refs.select as any;
      console.log("Clicked login");
      if (view.onLogin) {
        const environment = select.value;
        view.onLogin(environment);
      }
    }
  }
})
export default class EnvironmentSelectorModal extends Vue {
  @Prop() onLogin?: OnLogin;

  get environments(): LoginEnvironment {
    return this.$store.getters.environments;
  }
}
